import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";

interface Props {
  shown: number;
  total: number;
  unit: "rows" | "bars" | "slices" | "points";
  onViewAll: () => void;
}

const SUMMARY_KEYS: Record<Props["unit"], string> = {
  rows: "chat.preview.showingRows",
  bars: "chat.preview.showingBars",
  slices: "chat.preview.showingSlices",
  points: "chat.preview.showingPoints"
};

const DreamerAttachmentPreviewFooter: React.FC<Props> = ({
  shown,
  total,
  unit,
  onViewAll
}) => {
  const { t } = useTranslation();
  const summaryKey = SUMMARY_KEYS[unit];
  return (
    <div className="flex items-center justify-between border-t border-border-border1 px-4 py-2">
      <Text variant="bodySecondary">
        {t(summaryKey, { shown, total })}
      </Text>
      <Button
        variant="tertiary"
        onClick={onViewAll}
        data-test="message-preview-view-all"
      >
        {t("chat.preview.viewAll")}
      </Button>
    </div>
  );
};

export default DreamerAttachmentPreviewFooter;
